export default "__VITE_ASSET__jXUsOdXZ__"